import type { QualityTier, QualitySettings } from './types';

export const QUALITY_TIERS: Readonly<Record<QualityTier, QualitySettings>> = {
  low: {
    tier: 'low',
    renderScale: 0.75,
    maxPixelRatio: 1,
    kuwaharaRadius: 0,
    lineWidthPxAt1080: 1.0,
    grain: true,
    craquelure: false,
  },
  medium: {
    tier: 'medium',
    renderScale: 1.0,
    maxPixelRatio: 1,
    kuwaharaRadius: 2,
    lineWidthPxAt1080: 0.9,
    grain: true,
    craquelure: true,
  },
  high: {
    tier: 'high',
    renderScale: 1.0,
    maxPixelRatio: 1.5,
    kuwaharaRadius: 3,
    lineWidthPxAt1080: 1.5,
    grain: true,
    craquelure: true,
  },
};

export function nextTier(t: QualityTier): QualityTier {
  switch (t) {
    case 'low':
      return 'medium';
    case 'medium':
      return 'high';
    case 'high':
      return 'low';
  }
}

export function renderSize(
  cssW: number,
  cssH: number,
  dpr: number,
  q: QualitySettings
): { readonly width: number; readonly height: number } {
  const effectiveDpr = Math.min(dpr, q.maxPixelRatio);
  const scale = q.renderScale * effectiveDpr;
  return {
    width: Math.floor(cssW * scale),
    height: Math.floor(cssH * scale),
  };
}
